/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import {
  string,
  arrayOf,
  shape,
  func,
} from 'prop-types';
import withApplicationConfig from 'containers/withApplicationConfig';
import { Heading, Paragraph, Small } from 'components/common';

import './RelationshipPanel.scss';

const RelationshipPanel = ({
  options,
  onChange,

  // App config
  relationshipPanel,
}) => (
  <div className="relationship-panel" data-selector="relationship-panel">
    <div className="title">
      <Paragraph secondary>
        <strong>{relationshipPanel.title}</strong>
      </Paragraph>
    </div>
    <div className="subtitle">
      <Small secondary>
        <em>{relationshipPanel.subtitle}</em>
      </Small>
    </div>
    <div className="relationship-panel-options" data-selector="relationship-panel-options" data-selector-type="relationship-panel-options">
      {options.map(({ label, value }) => (
        <div
          className="relationship-panel-option"
          key={value}
          onClick={() => (onChange ? onChange({ label, value }) : undefined)}
          data-selector-value={value}
          data-selector-type="relationship-panel-option"
        >
          <Heading as="h2">
            {label || value}
          </Heading>
        </div>
      ))}
    </div>
  </div>
);

RelationshipPanel.propTypes = {
  options: arrayOf(shape({
    label: string,
    value: string,
  })),
  onChange: func,
  relationshipPanel: shape({}),
};

RelationshipPanel.defaultProps = {
  options: [],
  onChange: undefined,
  relationshipPanel: {},
};

export default withApplicationConfig(RelationshipPanel, 'funnel-components');
